import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#1A1A1A] text-white py-12 px-4 border-t border-gray-800" data-id="element-79">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-80">
        <div className="w-full bg-white/5 rounded-2xl p-6 mb-12 text-center border border-white/10" data-id="element-81">
          <h2 className="text-xl md:text-2xl font-bold text-white tracking-wide" data-id="element-82">
            MegaPack Cursada Sin Estrés{' '}
            <span className="text-turquoise mx-2" data-id="element-83">|</span> Recursos para
            Estudiantes Universitarios
          </h2>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8 items-center text-center md:text-left" data-id="element-84">
          <div className="text-white/70 text-sm font-medium" data-id="element-85">
            © 2025 Todos los derechos reservados. InfinitaMente Digital.
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center md:justify-end gap-6 text-sm font-medium" data-id="element-86">
            <span className="text-white/70" data-id="element-87">Encontranos en:</span>
            <a href="#" className="flex items-center gap-2 hover:text-coralOrange transition-colors duration-300 group" data-id="element-88">
              <InstagramIcon className="w-5 h-5 text-coralOrange group-hover:scale-110 transition-transform duration-300" data-id="element-89" />
              @infinitamente.digital
            </a>
            <a href="mailto:soporteinfinitamente@gmail.com" className="flex items-center gap-2 hover:text-turquoise transition-colors duration-300 group" data-id="element-90">
              <MailIcon className="w-5 h-5 text-turquoise group-hover:scale-110 transition-transform duration-300" data-id="element-91" />
              soporteinfinitamente@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>;
}